import { type Extendable } from '@/types/props';

type Props = Extendable;

const HeadingText = ({ children, className }: Props) => (
  <p
    className={`font-headings text-xl font-semibold tracking-tight text-gray-900 md:text-2xl ${className}`}
  >
    {children}
  </p>
);

export { HeadingText };
export type { Props as HeadingTextProps };
